import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';

import PremiumIcon from '~/components/search/results/PremiumIcon';

import css from './index.css';

const dataQa = (name) => `qa-search-result-details-${name}`;

const PremiumMark = connect((state) => ({hidden: state.loads.premiumToolTipHidden}))(({hidden}) => (
  <div className={cs(css.premiumPlaceholder, dataQa('premium-desc'))}>
    This is a Premium Load
  </div>
));


export default PremiumMark;



// WEBPACK FOOTER //
// ./src/components/common/PremiumMark/index.js